import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { initMetaPixel } from './lib/metaPixel';
// Set the browser tab title as early as possible (at bundle execution time)
// so it overrides the default project title on the published page.
document.title = 'Control Total Hoy';
// Load the Meta Pixel and fire PageView on initial load.
initMetaPixel();
render(<App data-id="element-195" />, document.getElementById('root'));